import React, { useEffect, useState } from "react";
import { Inbox } from "lucide-react";
import { useI18n } from "../../i18n";
import { api } from "../../lib/api";

export default function Leads() {
  const { t } = useI18n();
  const [leads, setLeads] = useState([]);
  useEffect(() => { api.get("/leads").then((r) => setLeads(r.data.leads || [])).catch(() => {}); }, []);
  const taxLabel = (tt) => ({ vat: t("tk_tax_vat"), excise: t("tk_tax_excise"), rett: t("tk_tax_rett") }[tt] || tt || "—");
  return (
    <div className="space-y-5" data-testid="leads-page">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-[hsl(217_63%_15%)] flex items-center justify-center"><Inbox className="h-5 w-5 text-white" /></div>
        <div>
          <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_leads")}</h1>
          <p className="text-sm text-muted-foreground">{t("leads_sub")}</p>
        </div>
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary text-muted-foreground">
            <tr>
              <th className="text-start p-3 font-medium">{t("leads_name")}</th>
              <th className="text-start p-3 font-medium">{t("leads_contact")}</th>
              <th className="text-start p-3 font-medium">{t("tk_tax")}</th>
              <th className="text-start p-3 font-medium">{t("leads_message")}</th>
              <th className="text-start p-3 font-medium">{t("leads_date")}</th>
            </tr>
          </thead>
          <tbody>
            {leads.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground" data-testid="leads-empty">{t("leads_empty")}</td></tr>}
            {leads.map((l) => (
              <tr key={l.id} data-testid={`lead-row-${l.id}`} className="border-t border-border">
                <td className="p-3 font-medium text-foreground">{l.name}</td>
                <td className="p-3 text-muted-foreground whitespace-nowrap">{l.phone} {l.email}</td>
                <td className="p-3"><span className="text-[11px] rounded-full bg-[hsl(158_64%_94%)] text-[hsl(158_64%_26%)] px-2 py-0.5">{taxLabel(l.tax_type)}</span></td>
                <td className="p-3 text-muted-foreground max-w-xs truncate">{l.message || "—"}</td>
                <td className="p-3 text-muted-foreground whitespace-nowrap">{(l.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
